import { render } from "./OtherLabDataFilter.vue?vue&type=template&id=c19e81ec"
import script from "./OtherLabDataFilter.vue?vue&type=script&lang=js"
export * from "./OtherLabDataFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__